import AddBox from "@mui/icons-material/AddBox";
import AlternateEmail from "@mui/icons-material/AlternateEmail";
import Assignment from "@mui/icons-material/Assignment";
import AttachMoney from "@mui/icons-material/AttachMoney";
import Dns from "@mui/icons-material/Dns";
import EvStation from "@mui/icons-material/EvStation";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import FindReplace from "@mui/icons-material/FindReplace";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import ListAltIcon from "@mui/icons-material/ListAlt";
import MessageIcon from "@mui/icons-material/Message";
import Receipt from "@mui/icons-material/Receipt";
import Storage from "@mui/icons-material/Storage";
import SupervisedUserCircle from "@mui/icons-material/SupervisedUserCircle";
import SupervisorAccount from "@mui/icons-material/SupervisorAccount";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import Hidden from "@mui/material/Hidden";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { makeStyles } from "@mui/styles";
import _ from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import packageInfo from "../../package.json";
import cpgLogo from "./Logo/Container-Port-White-Logotype.png";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
   root: {
      display: "flex",
   },
   drawer: {
      [theme.breakpoints.up("sm")]: {
         width: drawerWidth,
         flexShrink: 0,
      },
   },
   toolbar: theme.mixins.toolbar,
   drawerPaper: {
      width: drawerWidth,
      backgroundColor: "#010440",
   },
   content: {
      flexGrow: 1,
      padding: theme.spacing(3),
   },
   listItem: {
      backgroundColor: "#010440",
      color: "white",
      "&:hover": {
         backgroundColor: "#808080",
      },
   },

   listItemText: {
      color: "white",
      paddingLeft: "1rem",
   },

   listItemSelected: {
      backgroundColor: "white",
      opacity: "75%",
      "&:hover": {
         backgroundColor: "white",
      },
   },

   listItemTextSelected: {
      color: "black",
      paddingLeft: "1rem",
   },

   listItemIconSelected: {
      color: "black",
      display: "contents",
      width: "max-content",
   },

   listItemIcon: {
      color: "white",
      display: "contents",
      width: "max-content",
   },

   hrStyle: {
      borderColor: "whitesmoke",
      padding: "0px",
      margin: "0px",
   },
   imgStyle: {
      height: "67px",
      padding: "2%",
      marginTop: "5px",
   },
   dividerImg: {
      backgroundColor: "#B0BBC3",
      height: "1px",
      marginTop: "7.5px",
      width: "85%",
      marginLeft: "1rem",
   },
   divImg: {
      textAlign: "center",
      backgroundColor: "#010440",
   },
}));

function Sidebar(props) {
   const { container } = props;
   const classes = useStyles();
   const [mobileOpen, setMobileOpen] = React.useState(false);
   const history = useHistory();

   let [state, setState] = useState({
      activeTab: "ratesearch",
   });

   let [open, setOpen] = useState({});

   useEffect(() => {
      var openRoutes = {};

      props.routes.forEach((route) => {
         if (route.subRoutes) {
            openRoutes[route.name] = false;
         }
      });

      setOpen(openRoutes);
   }, []);

   const handleDrawerToggle = () => {
      setMobileOpen(!mobileOpen);
   };

   function handleClick(route) {
      setState({
         ...state,
         activeTab: route.name,
      });

      history.push(route.path);
   }

   let sidebarRoutes = props.routes.filter((rt) => rt.sidebar === true);

   const drawer = (
      <div className={classes.toolbar}>
         <List>
            {sidebarRoutes.map((route) =>
               route.subRoutes ? (
                  <>
                     <ListItem
                        button
                        key={route.name}
                        onClick={() => setOpen({ ...open, [route.name]: !open[route.name] })}
                        className={route.name === state.activeTab ? classes.listItemSelected : classes.listItem}
                     >
                        <ListItemIcon
                           className={
                              route.name === state.activeTab ? classes.listItemIconSelected : classes.listItemIcon
                           }
                        >
                           {route.icon}
                        </ListItemIcon>
                        <ListItemText
                           primary={route.text}
                           className={
                              route.name === state.activeTab ? classes.listItemTextSelected : classes.listItemText
                           }
                        />
                        {open[route.name] ? (
                           <ExpandLess style={{ color: "white" }} />
                        ) : (
                           <ExpandMore style={{ color: "white" }} />
                        )}
                     </ListItem>
                     <Collapse in={open[route.name]} timeout="auto" unmountOnExit>
                        {route.subRoutes.map((sub) => {
                           return (
                              <ListItem
                                 button
                                 key={sub.name}
                                 onClick={() => handleClick(sub)}
                                 className={sub.name === state.activeTab ? classes.listItemSelected : classes.listItem}
                              >
                                 <ListItemIcon
                                    className={
                                       sub.name === state.activeTab
                                          ? classes.listItemIconSelected
                                          : classes.listItemIcon
                                    }
                                    sx={{ color: "white" }}
                                 >
                                    {sub.icon}
                                 </ListItemIcon>
                                 <ListItemText
                                    primary={sub.text}
                                    className={
                                       sub.name === state.activeTab
                                          ? classes.listItemTextSelected
                                          : classes.listItemText
                                    }
                                 />
                              </ListItem>
                           );
                        })}
                     </Collapse>
                  </>
               ) : (
                  <ListItem
                     button
                     key={route.name}
                     onClick={() => handleClick(route)}
                     className={route.name === state.activeTab ? classes.listItemSelected : classes.listItem}
                  >
                     <ListItemIcon
                        className={route.name === state.activeTab ? classes.listItemIconSelected : classes.listItemIcon}
                     >
                        {route.icon}
                     </ListItemIcon>
                     <ListItemText
                        primary={route.text}
                        className={route.name === state.activeTab ? classes.listItemTextSelected : classes.listItemText}
                     />
                  </ListItem>
               ),
            )}
            <div
               style={{
                  position: "fixed",
                  bottom: "10px",
                  backgroundColor: "#010440",
                  color: "white",
                  width: "240px",
                  textAlign: "center",
               }}
            >
               Version: {packageInfo.version}
            </div>
         </List>
      </div>
   );

   return (
      <div className={classes.root}>
         <nav className={classes.drawer}>
            <Divider className={classes.hrStyle} />
            <Hidden smUp implementation="css">
               <Drawer
                  container={container}
                  variant="temporary"
                  anchor={"left"}
                  open={mobileOpen}
                  onClose={handleDrawerToggle}
                  classes={{
                     paper: classes.drawerPaper,
                  }}
                  ModalProps={{
                     keepMounted: true,
                  }}
               >
                  {drawer}
               </Drawer>
            </Hidden>
            <Hidden xsDown implementation="css">
               <Drawer
                  classes={{
                     paper: classes.drawerPaper,
                  }}
                  variant="permanent"
                  open
               >
                  <div className={classes.divImg}>
                     <img className={classes.imgStyle} src={cpgLogo}></img>
                  </div>
                  <Divider className={classes.dividerImg} />
                  {drawer}
               </Drawer>
            </Hidden>
         </nav>
      </div>
   );
}

Sidebar.propTypes = {
   routes: PropTypes.array.isRequired,
};

Sidebar.defaultProps = {
   routes: [],
};

function mapStateToProps(state, ownProps) {
   let props = {
      routes: [],
      parentState: ownProps.parentState,
      setParentState: ownProps.setParentState,
   };

   if (state.user.currentUser.security.admin) {
      props.routes = [
         {
            name: "orders",
            icon: <Receipt />,
            text: "Quotes",
            sidebar: true,
            subRoutes: [
               {
                  name: "orders",
                  icon: <Assignment style={{ marginLeft: "1rem" }} />,
                  text: "Quotes",
                  sidebar: true,
                  path: "/orders",
               },
               {
                  name: "ordersnew",
                  icon: <AddBox style={{ marginLeft: "1rem" }} />,
                  text: "New Quote",
                  sidebar: true,
                  path: "/orders/new",
               },
            ],
         },
         {
            name: "ratemanagement",
            icon: <Dns />,
            text: "Rate Management",
            sidebar: true,
            subRoutes: [
               {
                  name: "ratemanagementsearch",
                  icon: <FindReplace style={{ marginLeft: "1rem" }} />,
                  text: "Rate Management",
                  sidebar: true,
                  path: "/ratemanagement",
               },
               {
                  name: "alias",
                  icon: <AlternateEmail style={{ marginLeft: "1rem" }} />,
                  text: "Alias",
                  sidebar: true,
                  path: "/alias",
               },
            ],
         },
         {
            name: "terminal",
            icon: <Storage />,
            text: "Terminals",
            sidebar: true,
            path: "/terminal",
         },
         {
            name: "customermngmnt",
            icon: <SupervisorAccount />,
            text: "Customers",
            sidebar: true,
            path: "/customer",
         },
         {
            name: "user",
            icon: <SupervisedUserCircle />,
            text: "Internal User",
            sidebar: true,
            path: "/user",
         },
         {
            name: "fuel",
            icon: <EvStation />,
            text: "Fuel",
            sidebar: true,
            path: "/fuel",
         },
         {
            name: "accessorial",
            icon: <AttachMoney />,
            text: "Accessorial",
            sidebar: true,
            subRoutes: [
               {
                  name: "accessorialtariff",
                  icon: <ListAltIcon style={{ marginLeft: "1rem" }} />,
                  text: "Accessorial Tariffs",
                  sidebar: true,
                  path: "/accessorialtariff",
               },
               {
                  name: "accessorialguide",
                  icon: <ImportContactsIcon style={{ marginLeft: "1rem" }} />,
                  text: "Accessorial Guide",
                  sidebar: true,
                  path: "/accessorialguide",
               },
            ],
         },
         {
            name: "adminmessagemanagement",
            icon: <MessageIcon />,
            text: "Message Management",
            sidebar: true,
            path: "/adminmessagemanagement",
         },
      ];
   } else {
      var permittedRoutes = _.filter(state.user.currentUser.security.routes, (rt) => rt.permission !== "none");

      props.routes = permittedRoutes.map((route) => {
         let newRoute = {};

         switch (route.module) {
            case "orders":
               newRoute.name = "orders";
               newRoute.icon = <Receipt />;
               newRoute.text = "Quotes";
               newRoute.sidebar = true;
               newRoute.path = "/orders";
               newRoute.order = 1;
               break;
            case "ratemanagement":
               newRoute.name = "ratemanagementsearch";
               newRoute.icon = <FindReplace />;
               newRoute.text = "Rate Management";
               newRoute.sidebar = true;
               newRoute.path = "/ratemanagement";
               newRoute.order = 2;
               break;
            case "customermanagement":
               newRoute.name = "customermngmnt";
               newRoute.icon = <SupervisorAccount />;
               newRoute.text = "Customers";
               newRoute.sidebar = true;
               newRoute.path = "/customer";
               newRoute.order = 3;
               break;
            case "termmanagement":
               newRoute.name = "terminal";
               newRoute.icon = <Storage />;
               newRoute.text = "Terminals";
               newRoute.sidebar = true;
               newRoute.path = "/terminal";
               newRoute.order = 4;
               break;
            case "intusermanagement":
               newRoute.name = "user";
               newRoute.icon = <SupervisedUserCircle />;
               newRoute.text = "Internal User";
               newRoute.sidebar = true;
               newRoute.path = "/user";
               newRoute.order = 5;
               break;
            case "fuel":
               newRoute.name = "fuel";
               newRoute.icon = <EvStation />;
               newRoute.text = "Fuel";
               newRoute.sidebar = true;
               newRoute.path = "/fuel";
               newRoute.order = 6;
               break;
            case "accessorial":
               newRoute.name = "accessorialtariff";
               newRoute.icon = <ListAltIcon />;
               newRoute.text = "Accessorial Tariffs";
               newRoute.sidebar = true;
               newRoute.path = "/accessorialtariff";
               newRoute.order = 7;
               break;
            case "alias":
               newRoute.name = "alias";
               newRoute.icon = <AlternateEmail />;
               newRoute.text = "Alias";
               newRoute.sidebar = true;
               newRoute.path = "/alias";
               newRoute.order = 8;
               break;
            default:
               newRoute.icon = "404";
               newRoute.sidebar = false;
               break;
         }

         return newRoute;
      });

      props.routes = _.orderBy(props.routes, (x) => x.order);
   }

   return props;
}

Sidebar.propTypes = {
   container: PropTypes.any,
};

Sidebar.defaultProps = {
   container: null,
};

export default withRouter(connect(mapStateToProps)(Sidebar));
